import { EditorExtensionEnum as e } from "../enums/editor-extensions-enum.mjs";
import { ToolbarOverflowSheet as t } from "../components/content-controls/toolbar-sheet.mjs";
import { useImageExtensionToolbar as n } from "../extensions/image-extension/use-image-extension-toolbar.mjs";
import { useFontFamilyExtensionToolbar as r } from "../extensions/font-family-extension/use-font-family-extension-toolbar.mjs";
import { useFontSizeExtensionToolbar as i } from "../extensions/font-size-extension/use-font-size-extension-toolbar.mjs";
import { useHeadingExtensionToolbar as a } from "../extensions/heading-extension/use-heading-extension-toolbar.mjs";
import { ListEnum as o } from "../extensions/list-extension/list-enum.mjs";
import { TextFormatEnum as s } from "../extensions/text-format-extension/text-format-enum.mjs";
import { useHistoryExtensionToolbar as ee } from "../extensions/history-extension/use-history-extension-toolbar.mjs";
import { useIndentExtensionToolbar as te } from "../extensions/indent-extension/use-indent-extension-toolbar.mjs";
import { useLineHeightExtensionToolbar as ne } from "../extensions/line-height-extension/use-line-height-extension-toolbar.mjs";
import { useLinkExtensionToolbar as re } from "../extensions/link-extension/use-link-extension-toolbar.mjs";
import { useListExtensionToolbar as c } from "../extensions/list-extension/use-list-extension-toolbar.mjs";
import { useParagraphSpaceExtensionToolbar as ie } from "../extensions/paragraph-extension/use-paragraph-space-extension.mjs";
import { useSpecialCharactersExtensionToolbar as ae } from "../extensions/special-characters-extension/use-special-characters-extension-toolbar.mjs";
import { useSubstitutesExtensionToolbar as oe } from "../extensions/substitutes-extension/use-substitutes-extension-toolbar.mjs";
import { useTextAlignExtensionToolbar as se } from "../extensions/text-align-extension/use-text-align-extension-toolbar.mjs";
import { useTextBackgroundColorExtensionToolbar as ce } from "../extensions/text-background-color-extension/use-text-background-color-extension-toolbar.mjs";
import { useTextColorExtensionToolbar as le } from "../extensions/text-color-extension/use-text-color-extension-toolbar.mjs";
import { useTextFormatExtensionToolbar as l } from "../extensions/text-format-extension/use-text-format-extension-toolbar.mjs";
import { getExistingExtensions as ue } from "../utils/get-extensions.mjs";
import { semanticOrder as de } from "./toolbar-semantic-order.mjs";
import { renderInSemanticOrder as u } from "./render-semantic-order.mjs";
import d, { Fragment as fe, useEffect as pe, useMemo as f, useRef as p, useState as me, useTransition as he } from "react";
import { twJoin as ge, twMerge as m } from "tailwind-merge";
import { jsx as h, jsxs as g } from "react/jsx-runtime";
//#region src/toolbar/index.tsx
var _ = ({ extensions: _, editor: v, toolbarStyles: _e, toolbarClassName: ve, showAllItems: y = !1, extensionOptions: b }) => {
	let { hasHistory: x, hasHeading: S, hasIndent: C, hasTextAlign: w, hasLink: T, hasTextColor: E, hasFontSize: D, hasTextBackgroundColor: O, hasFontFamily: k, hasSubstitution: A, hasSpecialCharacters: j, hasImage: M, hasOrderedList: N, hasBulletList: P, hasListItem: F, hasBold: I, hasItalic: L, hasUnderline: R, hasStrike: ye, hasParagraph: z, hasSimpleHardBreak: B, hasLineHeight: V } = ue(_), H = p(null), U = p(null), [W, G] = me([]), [, K] = he(), q = p([]), J = n(v, b?.[e.Image]), Y = ee(v), X = te(v), Z = re(v, b?.[e.Link]), be = se(v), xe = a(v), Se = oe(v, b?.[e.Substitution]), Ce = l(v, s.Bold), we = l(v, s.Italic), Te = l(v, s.Underline), Ee = l(v, s.Strike), De = i(v, b?.[e.FontSize]), Oe = c(v, o.OrderedList), Q = c(v, o.BulletList), ke = r(v, b?.[e.FontFamily]), Ae = le(v, b?.[e.TextColor]), je = ce(v, b?.[e.TextBackgroundColor]), Me = ae(v), Ne = ie(v), Pe = ne(v), $ = f(() => {
		let t = [], n = (e, n) => {
			Array.isArray(e) ? e.forEach((e, r) => {
				t.push({
					id: `${n}-${r}`,
					toolbarItem: e,
					ref: d.createRef(),
					key: n
				});
			}) : t.push({
				id: n,
				toolbarItem: e,
				ref: d.createRef(),
				key: n
			});
		};
		return z && !B && n(Ne, e.Paragraph), V && n(Pe, e.LineHeight), x && n(Y, e.History), M && n(J, e.Image), T && n(Z, e.Link), C && n(X, e.Indent), w && n(be, e.TextAlign), S && n(xe, e.Heading), A && n(Se, e.Substitution), I && n(Ce, e.Bold), L && n(we, e.Italic), R && n(Te, e.Underline), ye && n(Ee, e.Strike), D && n(De, e.FontSize), N && F && n(Oe, e.OrderedList), P && F && n(Q, e.BulletList), k && n(ke, e.FontFamily), E && n(Ae, e.TextColor), O && n(je, e.TextBackgroundColor), j && n(Me, e.SpecialCharacters), t;
	}, [
		z,
		B,
		Ne,
		V,
		Pe,
		x,
		Y,
		M,
		J,
		T,
		Z,
		C,
		X,
		w,
		be,
		S,
		xe,
		A,
		Se,
		I,
		Ce,
		L,
		we,
		R,
		Te,
		ye,
		Ee,
		D,
		De,
		N,
		F,
		Oe,
		P,
		Q,
		k,
		ke,
		E,
		Ae,
		O,
		je,
		j,
		Me
	]), Fe = (e, t) => e.length === t.length && e.every((e, n) => e === t[n]);
	pe(() => {
		let e = () => {
			if (!H.current) return;
			if (y) {
				let e = $.map((e) => e.id);
				Fe(q.current, e) || (q.current = e, K(() => G(e)));
				return;
			}
			let e = H.current.clientWidth, t = [...$].sort((e, t) => de.flatMap((e) => e).indexOf(e.key) - de.flatMap((e) => e).indexOf(t.key)), n = [], r = 0, i = !1, a = U.current?.offsetWidth ?? 0;
			for (let a of t) {
				let t = a.ref.current;
				if (!t) continue;
				let o = t.offsetWidth, s = r + o;
				!i && s <= e ? (n.push(a.id), r = s) : i = !0;
			}
			i && n.length > 0 && r + a > e && n.pop(), Fe(q.current, n) || (q.current = n, K(() => G(n)));
		}, t = new ResizeObserver(e);
		return H.current && t.observe(H.current), e(), () => {
			t.disconnect();
		};
	}, [$, y]);
	let Ie = f(() => $.filter((e) => W.includes(e.id)), [$, W]), Le = f(() => $.filter((e) => !W.includes(e.id)), [$, W]);
	return /* @__PURE__ */ g("div", {
		style: _e,
		className: m("border-border-200 bg-bg-primary sticky top-[var(--sticky-top,0px)] z-10 flex items-center rounded-t-lg border border-b-0 p-1", ve),
		children: [
			/* @__PURE__ */ g("div", {
				ref: H,
				className: m("flex w-full", y && "flex-wrap gap-1"),
				children: [u({
					source: Ie,
					skipRef: !0
				}), /* @__PURE__ */ h("div", {
					ref: U,
					className: ge("ml-auto flex items-center", Le.length > 0 ? "visible" : "invisible", y && "hidden"),
					children: /* @__PURE__ */ h(t, { children: u({
						source: Le,
						skipRef: !0,
						inSheet: !0
					}) })
				})]
			}),
			/* @__PURE__ */ h("div", {
				"aria-hidden": !0,
				className: "pointer-events-none absolute top-0 left-0 flex h-0 overflow-hidden opacity-0",
				inert: !0,
				children: u({ source: $ })
			}),
			$.filter(({ toolbarItem: e }) => e.additionalRender).map(({ toolbarItem: e, id: t }) => /* @__PURE__ */ h(fe, { children: e.additionalRender }, `${t}-additional-render`))
		]
	});
};
//#endregion
export { _ as Toolbar };
